var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c(_vm.loader,{tag:"component",attrs:{"data":_vm.data,"options":_vm.options,"additional":_vm.additional}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }